
import { Menu, Modal } from "antd";
import Sider from "antd/lib/layout/Sider";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import { LeftSiderBarWith } from "../../../constants/constants";
import { ROUTE_PATHS } from "../../../constants/url-config";
import { hideBreadcrumbBar, setTitle } from "../../../redux/actions/header.action";
import { authorizedRouters, Route } from "../../../routing";
import { ROUTING_HELPER } from "../../../utils/routing-helper";
import { LogoutIcon } from "../icon";
import "./sider-bar.scss";
import HISTORY from "../../../utils/history.helper";

const { SubMenu } = Menu;

const menuRouters = authorizedRouters.filter(p => p.showOnMenu);

interface Props {
    logout: () => void;
}

const AppSiderBar = (props: Props) => {

    const { t } = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();
    const firstlevelMenus = menuRouters.filter(p => !p.parentId);
    const [menuSelectedKeys, setMenuSelectedKeys] = useState<string[]>();
    const openKey = useRef(ROUTING_HELPER.getMenuSeletedKeys(location.pathname));

    const renderLink = (href: string | undefined, name: string | undefined, title: string | undefined) => {
        if (href !== undefined) {
            return <Link to={href} >
                <span>
                    {name ?? title}
                </span>
            </Link>
        } else {
            return <span className="blue-text">
                {name ?? title}
            </span>
        }
    }

    const subMenuClick = (e: any, href: string | undefined) => {
        console.log(e);
        if (href) {
            HISTORY.push(href)
        }
    }

    const renderFirstLevel = (menu: Route) => {
        const subMenus = menuRouters.filter(p => p.parentId === menu.id);

        if (subMenus && subMenus.length) {
            return (
                <SubMenu onTitleClick={(e) => subMenuClick(e, menu.href)} key={menu.id} icon={menu.icon} title={menu.title} className={`level-item-${1}`}>
                    {subMenus.map((menu, index) => (
                        <React.Fragment key={index}>
                            {renderSecondLevel(menu)}
                        </React.Fragment>
                    ))}
                </SubMenu>
            )
        }

        return (
            <Menu.Item key={menu.id} icon={menu.icon} className={`level-item-${1}`}>
                {
                    renderLink(menu.href, menu.menuName, menu.title)
                }
            </Menu.Item>
        )
    }

    const renderSecondLevel = (menu: Route) => {
        const subMenus = menuRouters.filter(p => p.parentId === menu.id);

        if (subMenus && subMenus.length) {
            return (
                <SubMenu onTitleClick={(e) => subMenuClick(e, menu.href)} key={menu.id} icon={menu.icon} title={menu.title} className={`level-item-${2}`}>
                    {subMenus.map((menu, index) => (
                        <React.Fragment key={index}>
                            {renderMenuItem(menu, 3)}
                        </React.Fragment>
                    ))}
                </SubMenu>
            )
        }

        return (
            <Menu.Item key={menu.id} icon={menu.icon} className={`level-item-${2}`}>
                {
                    renderLink(menu.href, menu.menuName, menu.title)
                }
            </Menu.Item>
        )
    }


    const renderMenuItem = (menu: Route, level: number) => {
        //const subMenus = menuRouters.filter(p => p.parentId === menu.id);

        return (
            <React.Fragment>
                <Menu.Item key={menu.id} icon={menu.icon} className={`level-item-${level}`}>
                    {
                        renderLink(menu.href, menu.menuName, menu.title)
                    }
                </Menu.Item>
                {/* {subMenus && subMenus.length &&
                    <Menu defaultSelectedKeys={menuSelectedKeys} selectedKeys={menuSelectedKeys} className="main-menu">
                        {subMenus.map((item, index) => (
                            <React.Fragment key={index}>
                                {renderMenuItem(item, level + 1)}
                            </React.Fragment>
                        ))}
                    </Menu>
                } */}
            </ React.Fragment>
        )
    }

    const confirmLogout = () => {
        Modal.confirm({
            content: t("Menu.logOutMessage"),
            onOk: signOut,
            cancelText: t("Global.lbCancel"),
            icon: '',
            width: 304
        });
    }

    const signOut = async () => {
        props.logout();
    };

    useEffect(() => {
        const selectedMenuIds = ROUTING_HELPER.getMenuSeletedKeys(location.pathname);
        setMenuSelectedKeys(selectedMenuIds);
        const currentMenuId = ROUTING_HELPER.getCurrentMenuId(location.pathname);
        const currentMenu = authorizedRouters.find(x => x.id === currentMenuId);
        if (currentMenu && currentMenu.title) {
            dispatch(setTitle(currentMenu.title));
        }

        dispatch(hideBreadcrumbBar(currentMenu?.hideBreadcrumb))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return (
        <Sider
            theme='light'
            className="sider-bar"
            width={LeftSiderBarWith}
        >
            <Link className="logo" to={ROUTE_PATHS.Home}>
                <img src={logo} alt="logo" />
            </Link>

            <Menu
                className="main-menu flex-1"
                mode="inline"
                selectedKeys={menuSelectedKeys}
                defaultSelectedKeys={menuSelectedKeys}
                defaultOpenKeys={openKey.current}
            >
                {firstlevelMenus.map((menu) => (
                    <React.Fragment key={menu.id}>
                        {renderFirstLevel(menu)}
                    </React.Fragment>
                ))}

            </Menu>
            <Menu
                className="main-menu"
                mode="inline"
                selectable={false}>
                <Menu.Item icon={<LogoutIcon />} className={`level-item-1`} onClick={() => { confirmLogout() }}>
                    {t('Menu.logOut')}
                </Menu.Item>
            </Menu>
        </Sider>
    )
}

export default AppSiderBar